import { render, staticRenderFns } from "./r-tutorial-kind.vue?vue&type=template&id=7e9176f2"
import script from "./r-tutorial-kind.vue?vue&type=script&lang=js"
export * from "./r-tutorial-kind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e9176f2')) {
      api.createRecord('7e9176f2', component.options)
    } else {
      api.reload('7e9176f2', component.options)
    }
    module.hot.accept("./r-tutorial-kind.vue?vue&type=template&id=7e9176f2", function () {
      api.rerender('7e9176f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/tutorial/r-tutorial-kind.vue"
export default component.exports